export enum NavigateDirection {
  next = 'next',
  prev = 'prev',
}
